import React from "react";
import { useNavigate } from "react-router-dom";

const CardMemories = () => {
  const navigate = useNavigate();
  return (
    <div className="p-2">
      {/* Page Styles */}
      <style>{`
       
        ::-webkit-scrollbar { width: 1px; height: 1px; }
        ::-webkit-scrollbar-button { width: 1px; height: 1px; }

        .external { overflow: hidden; height: 80vh; }

        .horizontal-scroll-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 90vh;
          transform: rotate(-90deg) translate3d(0, -100vh, 0);
          transform-origin: right top;
          overflow-y: auto;
          overflow-x: hidden;
          height: 100vw;
          perspective: 1px;
          transform-style: preserve-3d;
          padding-bottom: 10rem;
        }

        .img-wrapper {
          transform: rotate(90deg);
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 40vh;
          transform-origin: 50% 50%;
          transform: rotate(90deg) translateZ(0.1px) scale(0.9)
            translateY(-3vh);
          transition: 1s;
        }

        .img-wrapper:hover { min-height: 65vh; }

        .slower { transform: rotate(90deg) translateZ(-0.2px) scale(1.1) translateY(-10vh); }
        .slower1 { transform: rotate(90deg) translateZ(-0.25px) scale(1.05) translateY(8vh); }
        .slower2 { transform: rotate(90deg) translateZ(-0.3px) scale(1.3) translateY(2vh); }
        .slower-down { transform: rotate(90deg) translateZ(-0.2px) scale(1.1) translateY(16vh); }
        .faster { transform: rotate(90deg) translateZ(0.15px) scale(0.8) translateY(14vh); }
        .faster1 { transform: rotate(90deg) translateZ(0.05px) scale(0.8) translateY(10vh); }
        .vertical { transform: rotate(90deg) translateZ(-0.15px) scale(1.15); }
        .last { transform: rotate(90deg) translateZ(-0.2px) scale(1.1) translateX(25vh) translateY(-8vh); }

        .img-wrapper a {
          overflow: hidden;
          display: block;
          padding: 1vh;
          background: #efecdb;
          box-shadow: 0 10px 50px #5f2f1182;
        }

        img {
          max-width: 45vh;
          max-height: 50vh;
          transition: 0.5s;
          filter: saturate(40%) sepia(50%) hue-rotate(5deg);
        }
img:hover { filter: none; }
      `}</style>

      {/* Header Link */}

      <p
        className="main-title"
        style={{
          fontSize: "40px",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        some of our memories all together, press to continue....
      </p>

      {/* Gallery */}
      <div className="external">
        <div className="horizontal-scroll-wrapper">
          {[
            ["slower", "paris-cafe-terrace.jpg"],
            ["faster", "antiquedollboy.jpg"],
            ["slower vertical", "windowshopclock.jpg"],
            ["slower slower-down", "swanduckriver.jpg"],
            ["", "cafe-terrace.jpg"],
            ["slower", "paris-seine-boat.jpg"],
            ["faster1", "old-man-river.jpg"],
            ["slower slower2", "cafe-table-street.jpg"],
            ["", "street-scene-people.jpg"],
            ["slower", "notre-dame-river-boat.jpg"],
            ["slower last", "shop-window-reflection.jpg"],
          ].map(([cls, img], i) => (
            <div key={i} className={`img-wrapper ${cls}`}>
              {/* <a target="_blank" rel="noopener noreferrer"> */}
              <img
                src={`https://s3-us-west-2.amazonaws.com/s.cdpn.io/74321/${img}`}
                alt=""
              />
              {/* </a> */}
            </div>
          ))}
        </div>
      </div>
      <div className="button flex justify-center">
        <button
          className="btn btn-next"
          data-next="letter"
          onClick={() => navigate(-1)}
        >
          Back
        </button>

        <button
          className="btn btn-next"
          onClick={() =>
            window.open(
              "https://api.whatsapp.com/send/?phone=%2B917893412318&text=I love you Kittu&type=phone_number&app_absent=1",
            )
          }
        >
          Wanna Chat ?
        </button>
      </div>
    </div>
  );
};

export default CardMemories;
